<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="ma-0 pa-0">
        <v-card class="elevation-0 transparent">
          <v-card-text >

            <div class="black--text text-h6">
              Total de horas:         {{ totalHoras }}
            </div>
            <br/>
            <v-row>

              <v-btn
              v-if="puedeSubirRequisicionNomina"
              color="orange"
              dark
              class="mr-2"
              @click="subirRequisicion()"
              outlined
              >
              Subir requisición
              <v-icon right small >mdi-lock</v-icon>
            </v-btn>

            <v-btn
            color="primary"
            dark
            @click="actualizarNomina()"
            outlined
            class="mr-2"
            >
            Actualizar
          </v-btn>

            <v-btn
              color="teal darken-1"
              dark
              class="mr-2"
              @click="verDesgloseGuardado()"
              outlined
              :disabled="!ciclo"
            >
              Desglose guardado
              <v-icon right small>mdi-history</v-icon>
            </v-btn>

            <v-btn
              v-if="!esNominaSinCantidades"
              color="red darken-1"
              class="mr-2"
              outlined
              :disabled="!ciclo"
              @click="abrirHuellas( 1 )"
            >
              Sin huella sabatino ({{ faltasHuellaSab.length }})
              <v-icon right small>{{ revisadoHuellaSab ? 'mdi-check-circle' : 'mdi-fingerprint-off' }}</v-icon>
            </v-btn>

            <v-btn
              v-if="!esNominaSinCantidades && quincenaHuellaActiva"
              color="red darken-1"
              class="mr-2"
              outlined
              :disabled="!ciclo"
              @click="abrirHuellas( 2 )"
            >
              Sin huella quincena ({{ faltasHuellaQuin.length }})
              <v-icon right small>{{ revisadoHuellaQuin ? 'mdi-check-circle' : 'mdi-fingerprint-off' }}</v-icon>
            </v-btn>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
            <v-text-field
            v-model="search"
            dense
            filled
            single-line
            label="Buscar"
            append-icon="mdi-magnify"
            ></v-text-field>  
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="black--text">
            <b>% aceptación Quincena:</b> {{ porcentajeAceptacionQ }} --- ST {{ dominicalSem + lvSem }}
            <br/>
            <b>% aceptación Bono:</b> {{ porcentajeAceptacionB }}
            <br/>
            <b>% aceptación Sabatina:</b> {{ porcentajeAceptacionA }} --- ST {{ sabatinoSem }}
          </v-col>

          <v-col cols="12" class="black--text">
            <b>TEACHERS APOYO LVD:</b> {{ (Number(lvSemT) || 0) + (Number(dominicalSemT) || 0) }}
            <br/>
            <b>TEACHERS APOYO SABATINO:</b> {{ Number(sabatinoSemT) || 0 }} 
          </v-col>
        </v-row>

        <v-row v-if="!liberar">
          <v-col cols="12" class="black--text">
            <label>Maestros sin categoria</label>
            <span v-for="( ma , i ) in maestros" :key="i" class="black--text"> {{ ma }}<br/></span>
          </v-col>
        </v-row>

        <v-row v-if="!liberar">
          <v-col cols="12" class="black--text">
            <v-alert
            dense
            outlined
            type="error"
            >
            Agrega la categoría a los maestros para poder liberar la nómina
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-if="!esNominaSinCantidades && (huellasPendientesRevision || errorExcepcionesHuella)">
        <v-col cols="12" class="black--text">
          <v-alert
            v-if="huellasPendientesRevision"
            dense
            outlined
            type="error"
          >
            Revisa los teachers sin huella
            <span v-if="huellaSabPendiente">(sabatino)</span>
            <span v-if="huellaQuinPendiente">(quincena)</span>
            antes de subir la requisición
          </v-alert>
          <v-alert
            v-if="errorExcepcionesHuella"
            dense
            outlined
            type="warning"
          >
            {{ errorExcepcionesHuella }}. Los descuentos se aplicaron sin excepciones.
          </v-alert>
        </v-col>
      </v-row>

      <v-tabs
        v-model="tab"
        align-with-title
      >
        <v-tabs-slider></v-tabs-slider>

        <!-- <v-tab v-if="liberar">Nómina</v-tab>
        <v-tab v-if="liberar">Disp. Horas Sab</v-tab>
        <v-tab v-if="[1,3].includes( selectedHeaders ) && liberar">Disp. Horas Quin</v-tab>
        <v-tab v-if="liberar">Comparativa Sab</v-tab>
        <v-tab v-if="[1,3].includes( selectedHeaders ) && liberar">Comparativa Quin</v-tab>
        <v-tab v-if="[1].includes( selectedHeaders ) && liberar">Comparativa Bonos</v-tab> -->

        <v-tab >Nómina</v-tab>
        <v-tab >Disp. Horas Sab</v-tab>
        <v-tab v-if="[1,3].includes( selectedHeaders )">Disp. Horas Quin</v-tab>
        <v-tab >Comparativa Sab</v-tab>
        <v-tab v-if="[1,3].includes( selectedHeaders )">Comparativa Quin</v-tab>
        <v-tab v-if="[1].includes( selectedHeaders )">Comparativa Bonos</v-tab>
      </v-tabs>

    <v-tabs-items v-model="tab">

      <!-- Nómina -->
      <v-tab-item>
        <v-card flat>
          <v-card-text>

            <v-radio-group
              v-model="opcionFiltro"
              row
              dense
            >
            <v-radio
            label="Pendiente"
            :value="0"
            ></v-radio>
            <v-radio
            label="Aceptados"
            :value="1"
            ></v-radio>
            <v-radio
            label="Rechazados"
            :value="2"
            ></v-radio>
            <v-radio
            label="Todos"
            :value="3"
            ></v-radio>

            <v-radio
            label="Sin categoría"
            :value="4"
            ></v-radio>

          </v-radio-group>

          <v-radio-group
            v-model="opcionSeguro"
            row
            dense
            class="mt-0"
          >
            <span class="black--text mr-3">Seguro:</span>
            <v-radio
            label="Seguro"
            :value="1"
            ></v-radio>
            <v-radio
            label="No seguro"
            :value="2"
            ></v-radio>
            <v-radio
            label="Todos"
            :value="0"
            ></v-radio>
          </v-radio-group>

          <v-spacer></v-spacer>
          <v-btn 
            class="mr-2" 
            small 
            dark 
            color="green"
            tile
            @click="exportar()"
          >
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>

        <v-data-table
          :headers="headersNominaVisibles"
          :items="filterTeachersSeguro"
          class="elevation-0"
          dense
          :search="search"
        >
        <template v-slot:item.seguro="{ item }">
          <v-switch
            :input-value="!!segurosTeachers[item.id_teacher]"
            color="green"
            dense
            hide-details
            class="mt-0 pt-0"
            @change="cambiarSeguro( item, $event )"
          ></v-switch>
        </template>

        <template v-slot:item.aceptado="{ item }">
          <v-chip v-if="(!item.aceptado)    " small color="grey"  dark >Pendiente</v-chip>
          <v-chip v-if="(item.aceptado == 1)" small color="green" dark >Aceptada</v-chip>
          <v-chip v-if="(item.aceptado == 2)" small color="red"   dark >Rechazada</v-chip>
        </template>

        <template v-slot:item.hsbc="{ item }">
          <v-chip v-if="(item.hsbc == 1)" small color="green" dark >Si</v-chip>
          <v-chip v-if="(item.hsbc == 2)" small color="red"   dark >No</v-chip>
        </template>

        <template v-slot:item.pago_quincena="{ item }">
          <v-chip 
          v-if="item.estatus_quincena" 
          :color="item.estatus_quincena == 1 ? 'green' : 'red'" 
          dark
          small 
          @click="verComentarios( item.comentarios_quincena, 2 , item )"
          >
          {{ item.pago_quincena }}
        </v-chip>

        <v-chip v-else color="grey" small dark @click="verComentarios( item.comentarios_quincena, 2 , item )">{{ item.pago_quincena }}</v-chip>
      </template>

      <template v-slot:item.PAGO_SABADO="{ item }">
        <v-chip 
        v-if="item.estatus_sabatina" 
        :color="item.estatus_sabatina == 1 ? 'green' : 'red'" 
        dark
        small 
        @click="verComentarios( item.comentarios_sabatina, 1 , item )"
        >
        {{ item.PAGO_SABADO }}
      </v-chip>

      <v-chip v-else color="grey" small dark @click="verComentarios( item.comentarios_sabatina, 1 , item )">{{ item.PAGO_SABADO }}</v-chip>
    </template>

    <template v-slot:item.bono_teacher="{ item }">
      <v-chip 
      v-if="item.estatus_bono" 
      :color="item.estatus_bono == 1 ? 'green' : 'red'" 
      dark
      small 
      @click="verComentarios( item.comentarios_bono, 3 , item )"
      >
      {{ item.bono_teacher }}
    </v-chip>

    <v-chip v-else color="grey" small dark @click="verComentarios( item.comentarios_bono, 3 , item )">{{ item.bono_teacher }}</v-chip>
  </template>

</v-data-table>
</v-card-text>
</v-card>
</v-tab-item>

<!-- Disperción de horas del sabatino -->
<v-tab-item>
  <v-card flat>
    <v-card-text>
      <v-data-table
      :headers="headersDispSabVisibles"
      :items="teachers"
      class="elevation-0"
      dense
      :search="search"
      >
    </v-data-table>
  </v-card-text>
</v-card>
</v-tab-item>

<!-- Disperción de horas del Quincena -->
<v-tab-item v-if="[1,3].includes( selectedHeaders )">
  <v-card flat>
    <v-card-text>
      <v-data-table
      :headers="headersDispQuinVisibles"
      :items="teachersQ"
      class="elevation-0"
      dense
      :search="search"
      >
    </v-data-table>
  </v-card-text>
</v-card>
</v-tab-item>

<!-- Comparativa del Sabatina -->
<v-tab-item>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="5">
          <label class="black--text"><b>Semana {{ selectedHeaders - 1 }}</b></label>
          <v-chip
            x-small
            color="teal lighten-4"
            class="ml-2"
            :title="usandoHistorialSab ? 'Datos del historial guardado al subir requisición' : 'Calculado al momento (sin historial)'"
          >
            {{ usandoHistorialSab ? 'historial' : 'cálculo' }}
          </v-chip>
          <v-alert
            v-if="!usandoHistorialSab && sinHistorialComparativaSab"
            dense
            outlined
            type="info"
            class="mt-2 mb-2"
          >
            No hay historial guardado de la semana anterior. Se muestra el cálculo en vivo.
          </v-alert>
          <v-data-table
          :headers="headersCompSabAntVisibles"
          :items="tabla2Comparativa"
          class="elevation-0"
          dense
          :search="search"
          >
        </v-data-table>
        <label v-if="!esNominaSinCantidades" class="text-h6"><b>Costo por hora: {{ costoHora1 }}</b></label>
        </v-col>

      <v-col cols="12" md="7">

        <label class="black--text"><b>Semana {{ selectedHeaders }}</b></label>
        <v-chip x-small color="blue lighten-4" class="ml-2" title="Calculado al momento con el rol de clases actual">cálculo</v-chip>
        <v-data-table
        :headers="headersCompSabActVisibles"
        :items="tabla1Comparativa"
        class="elevation-0"
        dense
        :search="search"
        >
      </v-data-table>
      <label v-if="!esNominaSinCantidades" class="text-h6"><b>Costo por hora: {{ costoHora2 }}</b></label>
      <br/>
      </v-col>

  <v-col cols="12">
    <div class="text-subtitle-1 font-weight-bold mb-1">Horas por grupo</div>
    <v-data-table
      :headers="headersHorasGruposSab"
      :items="filasHorasGruposSab"
      item-key="clave"
      dense
      :items-per-page="10"
      class="elevation-0"
      :item-class="claseFilaHorasGrupo"
      no-data-text="Ningún grupo cambió de horas"
    >
      <template v-slot:item.diferencia="{ item }">
        <b :class="item.diferencia > 0 ? 'green--text text--darken-2' : 'red--text text--darken-2'">
          {{ formatoHorasCambio(item.diferencia) }}
        </b>
      </template>
      <template v-slot:body.append>
        <tr class="font-weight-bold">
          <td>Total</td>
          <td class="text-right">{{ totalHorasAnteriorSab }}</td>
          <td class="text-right">{{ totalHorasActualSab }}</td>
          <td class="text-right">
            <span :class="totalHorasGruposSab > 0 ? 'green--text text--darken-2' : (totalHorasGruposSab < 0 ? 'red--text text--darken-2' : '')">
              {{ formatoHorasCambio(totalHorasGruposSab) }}
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-col>
</v-row>
</v-card-text>
</v-card>
</v-tab-item>

<!-- Comparativa de la quincena -->
<v-tab-item v-if="[1,3].includes( selectedHeaders )">
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="5">
          <label class="black--text"><b>Quincena {{ 1 }}</b></label>
          <v-chip x-small color="teal lighten-4" class="ml-2" title="Calculado del ciclo anterior">cálculo</v-chip>
          <v-data-table
          :headers="headersCompSabAntVisibles"
          :items="tabla2ComparativaQ"
          class="elevation-0"
          dense
          :search="search"
          >
        </v-data-table>
        <label v-if="!esNominaSinCantidades" class="text-h6"><b>Costo por hora: {{ costoHora1 }}</b></label>
        </v-col>

      <v-col cols="12" md="7">

        <label class="black--text"><b>Quincena {{ 2 }}</b></label>
        <v-data-table
        :headers="headersCompSabActVisibles"
        :items="tabla1ComparativaQ"
        class="elevation-0"
        dense
        :search="search"
        >
      </v-data-table>
      <label v-if="!esNominaSinCantidades" class="text-h6"><b>Costo por hora: {{ costoHora2 }}</b></label>
      <br/>

      <div class="mt-3 mb-2">
        <v-simple-table dense class="elevation-0" style="max-width: 360px;">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"></th>
                <th class="text-right">INBI</th>
                <th class="text-right">FAST</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Grupos Dominicales</td>
                <td class="text-right">{{ desgloseNotasQuincena.inbi.dominicales }}</td>
                <td class="text-right">{{ desgloseNotasQuincena.fast.dominicales }}</td>
              </tr>
              <tr>
                <td>Grupos entre semana</td>
                <td class="text-right">{{ desgloseNotasQuincena.inbi.entreSemana }}</td>
                <td class="text-right">{{ desgloseNotasQuincena.fast.entreSemana }}</td>
              </tr>
              <tr>
                <td><b>Total de grupos</b></td>
                <td class="text-right"><b>{{ desgloseNotasQuincena.inbi.dominicales + desgloseNotasQuincena.inbi.entreSemana }}</b></td>
                <td class="text-right"><b>{{ desgloseNotasQuincena.fast.dominicales + desgloseNotasQuincena.fast.entreSemana }}</b></td>
              </tr>
              <tr>
                <td>Grupos cambiados</td>
                <td class="text-right">{{ desgloseNotasQuincena.inbi.cambiados }}</td>
                <td class="text-right">{{ desgloseNotasQuincena.fast.cambiados }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
  </v-col>

  <v-col cols="12">
    <div class="text-subtitle-1 font-weight-bold mb-1">Horas por grupo</div>
    <v-data-table
      :headers="headersHorasGruposQ"
      :items="filasHorasGruposQ"
      item-key="clave"
      dense
      :items-per-page="10"
      class="elevation-0"
      :item-class="claseFilaHorasGrupo"
      no-data-text="Ningún grupo cambió de horas"
    >
      <template v-slot:item.diferencia="{ item }">
        <b :class="item.diferencia > 0 ? 'green--text text--darken-2' : 'red--text text--darken-2'">
          {{ formatoHorasCambio(item.diferencia) }}
        </b>
      </template>
      <template v-slot:body.append>
        <tr class="font-weight-bold">
          <td>Total</td>
          <td class="text-right">{{ totalHorasAnteriorQ }}</td>
          <td class="text-right">{{ totalHorasActualQ }}</td>
          <td class="text-right">
            <span :class="totalHorasGruposQ > 0 ? 'green--text text--darken-2' : (totalHorasGruposQ < 0 ? 'red--text text--darken-2' : '')">
              {{ formatoHorasCambio(totalHorasGruposQ) }}
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-col>
</v-row>
</v-card-text>
</v-card>
</v-tab-item>

<!-- Comparativa de bonos -->
<v-tab-item v-if="[1].includes( selectedHeaders )">
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" v-if="bonosHistorialActual.length" class="pb-0">
          <v-alert dense text type="info" class="mb-2">
            Comparativa alineada al historial de requi (total máximo guardado de la semana).
          </v-alert>
        </v-col>
        <v-col cols="12">
          <v-data-table
          :headers="headersBonoVisibles"
          :items="tablaBonos"
          class="elevation-0"
          dense
          :search="search"
          >
        </v-data-table>
      </v-col>
    </v-row>
  </v-card-text>
</v-card>
</v-tab-item>
</v-tabs-items>

</v-card-text>
</v-card> 
</v-col>
</v-row>

<v-dialog
v-model="dialogVerComentario"
max-width="500px"
v-if="comentarios"
>
<v-card>
  <v-card-title primary-title>
    Comentarios de nómina
  </v-card-title>
  <v-card-actions>
    <v-row>
      <v-col cols="12"
      v-for="(mensaje, i) in comentarios" :key="i"
      >
      <p 
      :class="`pa-2 ma-0 mb-4 ${ mensaje.id_usuario != getdatosUsuarioERPERP.iderp ? 'mensajeIzq' : 'mensajeDer' }`">
      {{ mensaje.comentarios }}
      <br/>
      {{ mensaje.nombre_completo }}
    </p>
  </v-col>
</v-row>
<br/>
</v-card-actions>
<v-card-text>
  <v-textarea
  v-model="respuesta"
  filled
  :rows="3"
  auto-grow
  label="respuesta al colaborador"
  ></v-textarea>
  <v-btn 
  color="success"
  @click="responder( )"
  tile
  >
  responder
</v-btn>
</v-card-text>
</v-card> 

</v-dialog>

<v-dialog
  v-model="dialogPagar"
  max-width="440px"
  persistent
>
  <v-card class="shadowCard" rounded="lg">
    <div class="text-center pt-6">
      <v-avatar color="orange lighten-5" size="72">
        <v-icon color="orange darken-2" size="40">mdi-file-document-check-outline</v-icon>
      </v-avatar>
    </div>

    <v-card-title class="justify-center text-h6 font-weight-bold pb-1">
      Confirmar requisición
    </v-card-title>

    <v-card-text class="text-center grey--text text--darken-1 px-8">
      Se generará la requisición de nómina de teachers y se guardará el desglose de la semana
      <strong> {{ selectedHeaders }}</strong>. ¿Deseas continuar?
    </v-card-text>

    <v-card-actions class="px-6 pb-6">
      <v-btn
        text
        color="grey darken-1"
        @click="dialogPagar = false"
        :disabled="cargar"
      >
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="orange darken-2"
        dark
        depressed
        rounded
        :loading="cargar"
        @click="pagar( )"
      >
        <v-icon left small>mdi-lock</v-icon>
        Sí, generar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Dialog Requis -->
<v-dialog
v-model="dialogRequis"
max-width="1200px"
>
<v-card>
  <v-card-title primary-title>
    Datos de la requisición
  </v-card-title>
  <v-card-text>

    <v-row>
      <!-- Seleccionar la requisición -->
      <v-col>
        <v-radio-group
        v-model="opEscuela"
        row
        >
        <v-radio
        label="Inbi"
        :value="1"
        ></v-radio>
        <v-radio
        label="Fast"
        :value="2"
        ></v-radio>
      </v-radio-group>
    </v-col>

    <!-- Seleccionar el tipo de requisición -->
    <v-col>
      <v-radio-group
      v-model="opRquisicion"
      row
      >
      <v-radio
      label="Sabatina"
      :value="1"
      ></v-radio>
      <v-radio
      label="Quincena"
      :value="2"
      ></v-radio>
      <v-radio
      label="Bono"
      :value="3"
      ></v-radio>
    </v-radio-group>
  </v-col>
</v-row>

<v-row>
  <v-col cols="12" v-if="opRquisicion == 1 && opEscuela == 1">
    <v-data-table
    :headers="headerRequiVisibles"
    :items="requisTeacherInbiS"
    class="elevation-0"
    dense
    >
    <template v-slot:item.costo_unitario="{ item }">
      <span>{{ format( item.costo_unitario ) }}</span>
    </template>

    <template v-slot:item.costo_total="{ item }">
      <span>{{ format( item.costo_total ) }}</span>
    </template>

  </v-data-table>
</v-col>

<v-col cols="12" v-if="opRquisicion == 1 && opEscuela == 2">
  <v-data-table
  :headers="headerRequiVisibles"
  :items="requisTeacherFastS"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>

<v-col cols="12" v-if="opRquisicion == 3 && opEscuela == 1">
  <v-data-table
  :headers="headerRequiVisibles"
  :items="detallesBonoInbi"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>


<v-col cols="12" v-if="opRquisicion == 2 && opEscuela == 1">
  <v-data-table
  :headers="headerRequiVisibles"
  :items="requisTeacherInbiQ"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>

<v-col cols="12" v-if="opRquisicion == 2 && opEscuela == 2">
  <v-data-table
  :headers="headerRequiVisibles"
  :items="requisTeacherFastQ"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>

<v-col cols="12" v-if="opRquisicion == 3 && opEscuela == 2">
  <v-data-table
  :headers="headerRequiVisibles"
  :items="detallesBonoFast"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>

</v-row>

</v-card-text>
<v-card-actions>
  <v-btn 
  color="success"
  @click="dialogPagar = true"
  outlined
  >
  Subir Requi
</v-btn>
</v-card-actions>
</v-card> 

</v-dialog>

<v-dialog
  v-model="dialogDesglose"
  max-width="1400px"
  scrollable
>
  <v-card>
    <v-card-title class="subtitle-1 font-weight-bold">
      Desglose guardado — Semana {{ selectedHeaders }}
      <v-spacer></v-spacer>
      <v-btn icon small @click="dialogDesglose = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-alert
        v-if="!desgloseHistorial.length && !cargar"
        type="info"
        dense
        outlined
      >
        No hay desglose guardado para esta semana. Se registra al subir la requisición.
      </v-alert>
      <template v-else>
        <v-row class="mb-2">
          <v-col cols="12" sm="6" md="5">
            <v-text-field
              v-model="searchDesglose"
              dense
              filled
              hide-details
              label="Buscar"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="7" class="text-right">
            <v-btn
              small
              dark
              color="green"
              tile
              :disabled="!desgloseHistorial.length"
              @click="exportarDesgloseHistorial()"
            >
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headersDesgloseVisibles"
          :items="desgloseHistorial"
          :search="searchDesglose"
          class="elevation-0"
          dense
          item-key="id_teacher"
        ></v-data-table>
      </template>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- Teachers sin huella -->
<v-dialog
  v-model="dialogHuellas"
  max-width="1300px"
  scrollable
>
  <v-card>
    <v-card-title class="subtitle-1 font-weight-bold">
      Sin huella — {{ tipoHuellas == 2 ? 'Quincena' : 'Sabatino' }}
      <v-spacer></v-spacer>
      <v-btn icon small @click="dialogHuellas = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-alert dense outlined type="info" class="mb-2">
        Días con clase presencial en los que el teacher no registró ninguna checada. No se pagan las horas de ese día salvo que se registre una excepción. Los grupos ONLINE no se validan.
      </v-alert>

      <v-row class="mb-2">
        <v-col cols="12" sm="6" md="5">
          <v-text-field
            v-model="searchHuellas"
            dense
            filled
            hide-details
            label="Buscar"
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="7" class="text-right black--text">
          <b v-if="!esNominaSinCantidades">Total a descontar:</b>
          <span v-if="!esNominaSinCantidades">{{ format( totalDescuentoHuellaVista ) }}</span>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headersHuellasVisibles"
        :items="faltasHuellaVista"
        :search="searchHuellas"
        class="elevation-0"
        dense
        item-key="clave"
      >
        <template v-slot:item.fecha="{ item }">
          {{ formatoFechaHuella( item.fecha ) }}
        </template>

        <template v-slot:item.monto="{ item }">
          <span :class="item.excepcion ? 'text-decoration-line-through grey--text' : 'red--text'">
            {{ format( item.monto ) }}
          </span>
        </template>

        <template v-slot:item.excepcion="{ item }">
          <v-chip v-if="!item.excepcion" small color="red" dark>Se descuenta</v-chip>
          <div v-else>
            <v-chip small color="green" dark>Justificado</v-chip>
            <div class="caption">
              {{ item.excepcion.motivo }}
              <span v-if="item.excepcion.usuario_autoriza"> — {{ item.excepcion.usuario_autoriza }}</span>
            </div>
          </div>
        </template>

        <template v-slot:item.acciones="{ item }">
          <v-btn
            v-if="!item.excepcion"
            small
            rounded
            outlined
            color="green"
            @click="abrirExcepcionHuella( item )"
          >
            Justificar
          </v-btn>
          <v-btn
            v-else
            small
            rounded
            outlined
            color="red"
            @click="eliminarExcepcionHuella( item )"
          >
            Quitar excepción
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="black"
        dark
        small
        rounded
        @click="dialogHuellas = false"
      >
        Cerrar
      </v-btn>
      <v-btn
        color="green"
        dark
        small
        rounded
        @click="marcarHuellasRevisadas( )"
      >
        <v-icon left small>mdi-check</v-icon>
        Marcar como revisado
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Justificar día sin huella -->
<v-dialog
  v-model="dialogExcepcionHuella"
  max-width="500px"
>
  <v-card v-if="faltaHuellaSeleccionada">
    <v-card-title class="subtitle-1 font-weight-bold">
      Justificar día sin huella
    </v-card-title>
    <v-card-text class="black--text">
      <div><b>Teacher:</b> {{ faltaHuellaSeleccionada.teacher }}</div>
      <div><b>Fecha:</b> {{ formatoFechaHuella( faltaHuellaSeleccionada.fecha ) }}</div>
      <div class="mb-3"><b>Monto:</b> {{ format( faltaHuellaSeleccionada.monto ) }}</div>
      <v-textarea
        v-model="motivoExcepcionHuella"
        filled
        dense
        rows="3"
        label="Motivo (obligatorio)"
        counter="500"
        maxlength="500"
      ></v-textarea>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="black"
        dark
        small
        rounded
        @click="dialogExcepcionHuella = false"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="green"
        dark
        small
        rounded
        :loading="cargar"
        @click="guardarExcepcionHuella( )"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Dialog de carga -->
<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
<carga                v-if="cargar"/>

</v-container>
</template>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores       from '@/mixins/validarErrores'
  import XLSX                 from 'xlsx'
  import funcionesExcel       from '@/mixins/funcionesExcel'
  import mixinNominaSabatina  from '@/mixins/mixinNominaSabatina'
  import mixinNominaQuincena  from '@/mixins/mixinNominaQuincena'
  import mixinNominaHuellas   from '@/mixins/mixinNominaHuellas'
  import { mapDetalleHistorialRows } from '@/utils/nominaTeachersHistorial'
  import {
    esNominaSinCantidades,
    puedeSubirRequisicionNomina,
    filtrarHeadersSinDinero,
  } from '@/utils/nominaPermisos'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel, mixinNominaSabatina, mixinNominaQuincena, mixinNominaHuellas ],

    props:[
      'selectedHeaders',
      'ciclo',
    ],

    data: () => ({
    // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      opcionFiltro: 3,
      opcionSeguro: 0,
      segurosTeachers: {},

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      teacherActivos:[],

      teachersBonos: [],

      teachers:[],
      teachersQ:[],

      headersNomina: [
        { text: 'id'                , value: 'id_teacher'           },
        { text: 'Teacher'           , value: 'teacher'              },  
        { text: 'Categoría'         , value: 'aceptado'             },  
        { text: 'HSBC'              , value: 'hsbc'                 },  
        { text: 'Plantel'           , value: 'plantel'              },  
        { text: 'existeCategoria'   , value: 'existeCategoria'      },  
        { text: 'PAGOS_DOBLES_SABADO'       , value: 'PAGO_SABADO', align: 'end'},  
      ],

      headers3: [
        { text: 'valor hora' , value: 'valor_hora'    },
        { text: '# horas'    , value: 'numero_horas'  },  
        { text: 'Costo'      , value: 'costo'         },  
      ],

      headers2: [
        { text: 'id'              ,  value: 'id_teacher'         },
        { text: 'Teacher'         ,  value: 'teacher'            },  
        { text: 'H_SABADO_FAST'   ,  value: 'HORAS_SABADO_FAST'  },  
        { text: 'H_SABADO_INBI'   ,  value: 'HORAS_SABADO_INBI'  },  
        { text: 'H_SABADO_TEENS'  ,  value: 'HORAS_SABADO_TEENS' },  
        { text: 'TOTAL_HORAS'     ,  value: 'TOTAL_HORAS'        },  
        { text: 'Costo H'         ,  value: 'categoria'          },  
        { text: 'PAGO_SABADO'     ,  value: 'PAGO_SABADO'        },  
        // { text: 'PAGO_DOBLES_SABADO'     ,  value: 'PAGO_DOBLES_SABADO'        },  
      ],

      headers4: [
        { text: 'valor hora' , value: 'valor_hora'    },
        { text: '# horas'    , value: 'numero_horas'  },  
        { text: 'Costo'      , value: 'costo'         },  
        { text: 'Diferencia' , value: 'diferencia'    },  
        { text: 'Motivo'     , value: 'motivo'        },  
      ],

      headers2Q: [
        { text: 'id'              ,  value: 'id_teacher'               },
        { text: 'Teacher'         ,  value: 'teacher'                  },  
        { text: 'H_LV_FAST'       ,  value: 'HORAS_ENTRE_SEMANA_FAST'  },  
        { text: 'H_D_FAST'        ,  value: 'HORAS_DOMINGO_FAST'       },  
        { text: 'H_ONL_TEENS'     ,  value: 'HORAS_LMV_FAST'           },  
        { text: 'H_LV_INBI'       ,  value: 'HORAS_ENTRE_SEMANA_INBI'  },  
        { text: 'H_D_INBI'        ,  value: 'HORAS_DOMINGO_INBI'       },  
        { text: 'H_ONL_TEENS'     ,  value: 'HORAS_LMV_INBI'           },
        { text: 'TOTAL_HORAS'     ,  value: 'HORAS_TOTALES'            },  
        { text: 'Costo H LV'      ,  value: 'categoria_lv'             }, 
        { text: 'Costo H D'       ,  value: 'categoria_d'              }, 
        { text: 'PAGO_TOTAL'      ,  value: 'PAGO_TOTAL'               },  
      ],

      headersBono: [
        { text: 'id'              , value: 'id_teacher'   },
        { text: 'Teacher'         , value: 'teacher'      },
        { text: 'PAGO Anterior'   , value: 'bono_anterior', align: 'end' } ,
        { text: 'PAGO BONO'       , value: 'bono_teacher', align: 'end' },  
        { text: 'diferencia'      , value: 'diferencia', align: 'end' }  
      ],

      headerRequi: [
        { text: 'ID Empleado'   , value: 'id_empleado'     },
        { text: 'Concepto'      , value: 'concepto'        },
        { text: 'Plantel'       , value: 'plantel'         },
        { text: 'Elemento'      , value: 'elemento'        , align: 'end' },
        { text: 'Costo U.'      , value: 'costo_unitario'  , align: 'end' },
        { text: 'Costo T'       , value: 'costo_total'     , align: 'end' },
      ],

      search:'',
      gruposActivos:[],

      tab: null,

      tabla1Comparativa: [],
      tabla2Comparativa: [],

      tabla1ComparativaQ: [],
      tabla2ComparativaQ: [],

      categorias1:[],
      categorias2:[],
      categorias1Q:[],
      categorias2Q:[],


      costoHora1: 0,
      costoHora2: 0,
      horasImpartidas: 0,
      horasImpartidasAnt: 0,

      costoHora1Q: 0,
      costoHora2Q: 0,
      horasImpartidasQ: 0,
      horasImpartidasAntQ: 0,

      gruposQuincena: [],
      gruposCicloActual: [],
      mapaConsecutivos: {},
      cicloAnt: null,
      comentariosT:[],
      dialogVerComentario: false,
      comentarios:[],
      porcentajeAceptacionQ:0,
      porcentajeAceptacionB:0,
      respuesta:'',
      gruposQuincenaAnt:[],

      gruposAllBono:[],
      tipo_nomina: 0,
      renglonNomina: null,
      rebajes: [],
      bonosTeachers:[],
      bonosAnterioresHistorial: [],
      bonosHistorialActual: [],
      sinHistorialComparativaSab: false,
      sinHistorialComparativaQuin: false,
      usandoHistorialSab: false,
      notasSabatinoHistorial: '',

      liberar: false,
      maestros: [],
      dialogPagar: false,
      dialogRequis: false,
      dialogDesglose: false,
      desgloseHistorial: [],
      searchDesglose: '',
      requisTeacherInbiS:[],
      requisTeacherInbiQ:[],
      requisTeacherFastS:[],
      requisTeacherFastQ:[],
      detallesBonoInbi:[],
      detallesBonoFast:[],
      opEscuela: 1,
      opRquisicion: 1,

      sabatinoSem: 0,
      dominicalSem: 0,
      lvSem: 0,
      sabatinoSemT: 0,
      dominicalSemT: 0,
      lvSemT: 0,
      horasDoblesSabatino: [],
    }),

computed: {

  ...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

  esNominaSinCantidades () {
    return esNominaSinCantidades(this.getdatosUsuarioERPERP)
  },

  puedeSubirRequisicionNomina () {
    return puedeSubirRequisicionNomina(this.getdatosUsuarioERPERP)
  },

  headersNominaVisibles () {
    const headers = this.headersNominaSeguro
    return this.esNominaSinCantidades ? filtrarHeadersSinDinero(headers) : headers
  },

  headersDesgloseVisibles () {
    const headers = this.headersNominaSeguro
    return this.esNominaSinCantidades ? filtrarHeadersSinDinero(headers) : headers
  },

  headersHuellasVisibles () {
    return this.esNominaSinCantidades ? filtrarHeadersSinDinero(this.headersHuellas) : this.headersHuellas
  },

  headersDispSabVisibles () {
    return this.esNominaSinCantidades ? filtrarHeadersSinDinero(this.headers2) : this.headers2
  },

  headersDispQuinVisibles () {
    return this.esNominaSinCantidades ? filtrarHeadersSinDinero(this.headers2Q) : this.headers2Q
  },

  headersCompSabAntVisibles () {
    return this.esNominaSinCantidades ? filtrarHeadersSinDinero(this.headers3) : this.headers3
  },

  headersCompSabActVisibles () {
    return this.esNominaSinCantidades ? filtrarHeadersSinDinero(this.headers4) : this.headers4
  },

  headersBonoVisibles () {
    return this.esNominaSinCantidades ? filtrarHeadersSinDinero(this.headersBono) : this.headersBono
  },

  headerRequiVisibles () {
    return this.esNominaSinCantidades ? filtrarHeadersSinDinero(this.headerRequi) : this.headerRequi
  },

  porcentajeAceptacionA( ){
    return this.calcPorcentajeAceptacion(this.teachers, 'estatus_sabatina')
  },

  headersNominaHuella( ){
    const headers = this.headersNomina.slice()
    headers.push({ text: 'DESC. HUELLA SAB', value: 'DESC_HUELLA_SAB', align: 'end' })
    if( this.quincenaHuellaActiva ){
      headers.push({ text: 'DESC. HUELLA QUIN', value: 'DESC_HUELLA_QUIN', align: 'end' })
    }
    return headers
  },

  filterTeachers( ){

    console.log( 'BONO TEACHERS', this.bonosTeachers )

    try{

      if( this.selectedHeaders == 1 && this.bonosTeachers.length ){
      
        for( const i in this.teachers ){

          const { id_teacher } = this.teachers[i]
              
          const existeBono = this.bonosTeachers.find( el => el.id_usuario == id_teacher )

          let totalBono = existeBono ? this.format( existeBono.monto ) : '$0.00'

          this.teachers[i]['bono_teacher'] = totalBono

        }

      }

    }catch( error ){

      console.log( error )

    }



    if( ![3,4].includes(this.opcionFiltro) ){


      if( this.opcionFiltro == 2 ){

            // return this.teachers.filter( el => el.estatus_quincena == 2 )
            // return this.teachers.filter( el => el.estatus_quincena == 2 || el.estatus_bono == 2 )
        return this.teachers.filter( el => el.estatus_sabatina == 2 )

      }else if( this.opcionFiltro == 1 ){

            // return this.teachers.filter( el => el.estatus_quincena == 1 && el.estatus_bono == 1 )
            // return this.teachers.filter( el => el.estatus_quincena == 1 && el.pago_quincena != '$0.00' )
        return this.teachers.filter( el => el.estatus_sabatina == 1 )

      }else{

            // return this.teachers.filter( el => el.estatus_quincena == 0  )
            // return this.teachers.filter( el => el.estatus_quincena == 0 || el.estatus_bono == 0 )
        return this.teachers.filter( el => el.estatus_sabatina == 0 )

      }

    }else{

      if( this.opcionFiltro == 3 ){

        return this.teachers

      }else{

        return this.teachers.filter( el => !el.existeCategoria )

      }

    }
  },

  headersNominaSeguro( ){
    const headers = this.headersNomina.slice()
    const posicion = headers.findIndex( el => el.value == 'aceptado' )
    headers.splice( posicion >= 0 ? posicion : 2, 0, { text: 'Seguro', value: 'seguro', sortable: false } )
    return headers
  },

  filterTeachersSeguro( ){
    if( this.opcionSeguro == 1 ){
      return this.filterTeachers.filter( el => this.segurosTeachers[el.id_teacher] )
    }
    if( this.opcionSeguro == 2 ){
      return this.filterTeachers.filter( el => !this.segurosTeachers[el.id_teacher] )
    }
    return this.filterTeachers
  },

  llaveSeguro( ){
    const id_ciclo = this.ciclo && this.ciclo.id_ciclo ? this.ciclo.id_ciclo : 0
    return id_ciclo + '-' + ( this.selectedHeaders || 0 )
  },


  teachersConBonoCompletos( ){
      // Une teachers del rol + quienes solo traen bono (no aparecen en grupos).
      const parseBono = (v) => {
        if (v == null || v === '') return 0
        if (typeof v === 'number') return v
        return parseFloat(String(v).replace(/[$,]/g, '')) || 0
      }
      const map = {}
      ;(this.teachers || []).forEach((t) => {
        if (!t || Number(t.id_teacher) >= 100000) return
        if (t.teacher === 'SIN TEACHER' || t.teacher === 'TOTAL') return
        map[Number(t.id_teacher)] = Object.assign({}, t)
      })
      ;(this.bonosTeachers || []).forEach((b) => {
        const id = Number(b.id_usuario || b.id_teacher)
        const monto = parseBono(b.monto)
        if (!id || monto <= 0) return
        if (map[id]) {
          map[id].bono_teacher = this.format(monto)
          return
        }
        map[id] = {
          id_teacher: id,
          teacher: b.nombre_completo || b.teacher || ('Teacher ' + id),
          plantel: b.plantel || '',
          id_plantel: b.id_plantel || 13,
          PAGO_SABADO: '$0.00',
          pago_quincena: '$0.00',
          PAGO_DOBLES: '$0.00',
          REBAJES: '$0.00',
          bono_teacher: this.format(monto),
        }
      })
      return Object.keys(map).map((k) => map[k])
  },

  tablaBonos( ){
      // FIJO: PAGO Anterior = requis CICLO 08_26 (17693+17694) = $29,700. Sin historial/API.
      const parseBono = (v) => {
        if (v == null || v === '') return 0
        if (typeof v === 'number') return v
        return parseFloat(String(v).replace(/[$,]/g, '')) || 0
      }
      const normalizarNombre = (nombre) => String(nombre || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase()

      const bonosFijos08_26 = [
        { id_teacher: 2995, teacher: "ABIGAIL MENDOZA CARREON", monto: 500 },
        { id_teacher: 2325, teacher: "ADRIAN ALEJANDRO DE LA GARZA BERNAL", monto: 500 },
        { id_teacher: 3010, teacher: "AIMAR ARMANDO OCAMPO GONZALEZ", monto: 350 },
        { id_teacher: 2176, teacher: "ALAN EDUARDO PALACIOS TAMEZ", monto: 500 },
        { id_teacher: 2961, teacher: "ALBERTO CRUZ VILLEGAS", monto: 350 },
        { id_teacher: 2220, teacher: "ALDO ALEJANDRO BENITEZ FUENTES", monto: 500 },
        { id_teacher: 2886, teacher: "ALEJANDRO RODRIGUEZ MORENO", monto: 500 },
        { id_teacher: 3134, teacher: "ALEJANDRO RAUL RODRIGUEZ RODRIGUEZ", monto: 500 },
        { id_teacher: 2940, teacher: "America Abigail Eguia Mancilla", monto: 350 },
        { id_teacher: 3037, teacher: "ANA NALLELY DE LA CRUZ DUQUE", monto: 350 },
        { id_teacher: 2735, teacher: "ANDREA DANAE LOZOYA MALDONADO", monto: 500 },
        { id_teacher: 2813, teacher: "ANGEL GUTIERREZ LUIS", monto: 350 },
        { id_teacher: 2530, teacher: "Angelique Sarahi Flores Resendiz", monto: 350 },
        { id_teacher: 1649, teacher: "CARLOS AMADOR CRUZ ANDRES", monto: 350 },
        { id_teacher: 2257, teacher: "CARLOS MINOR ZUNIGA", monto: 500 },
        { id_teacher: 2802, teacher: "CRISTOFER LEONARDO FRAUSTO ARAUJO", monto: 350 },
        { id_teacher: 1595, teacher: "DANA CAMILA LOPEZ SALDAÑA", monto: 500 },
        { id_teacher: 2744, teacher: "DANIEL DOMINGUEZ ROGRIGUEZ", monto: 350 },
        { id_teacher: 2977, teacher: "DANIEL OCHOA VALDEZ", monto: 350 },
        { id_teacher: 3008, teacher: "DANIELA MICHELLE GONZALEZ PADILLA", monto: 350 },
        { id_teacher: 1977, teacher: "DANIELA VERA CHAVEZ", monto: 350 },
        { id_teacher: 1380, teacher: "daphne elizabeth aviles", monto: 350 },
        { id_teacher: 2246, teacher: "DEYRA SHANDEL GUADIAN ALONZO", monto: 350 },
        { id_teacher: 2838, teacher: "DIANA LAURA GALEANA FERNANDEZ", monto: 350 },
        { id_teacher: 2514, teacher: "Edgar Aguilar Campos", monto: 500 },
        { id_teacher: 1534, teacher: "edson giovani lerma hernandez", monto: 350 },
        { id_teacher: 995, teacher: "Eduardo Barrón Uresti", monto: 350 },
        { id_teacher: 2274, teacher: "ESTIBALIS ABIGAIL ZARATE CRUZ", monto: 500 },
        { id_teacher: 1579, teacher: "FERNANDA TORRES RODRIGUEZ", monto: 500 },
        { id_teacher: 3026, teacher: "FERNANDO DANIEL GOMEZ TORRES", monto: 350 },
        { id_teacher: 2296, teacher: "FERNANDO FRANCISCO MENDIOLA AGUILLON", monto: 350 },
        { id_teacher: 2865, teacher: "FRANCISCO ERNESTO FLORES MENDEZ", monto: 350 },
        { id_teacher: 2131, teacher: "FRANCISCO JAVIER CHAPA GARZA", monto: 500 },
        { id_teacher: 495, teacher: "Frida Sophia Perez Trujillo", monto: 350 },
        { id_teacher: 1652, teacher: "GABRIELA HERNANDEZ VAZQUEZ", monto: 500 },
        { id_teacher: 1736, teacher: "Gabriela Rubio Campos", monto: 500 },
        { id_teacher: 545, teacher: "Génesis Rodríguez Burrola", monto: 350 },
        { id_teacher: 3125, teacher: "GRECIA FABIOLA VASQUEZ ROMERO", monto: 500 },
        { id_teacher: 2792, teacher: "HECTOR EMILIO ORTIZ OLALDE", monto: 350 },
        { id_teacher: 2280, teacher: "ISAEL EDUARDO GONZALEZ CRUZ", monto: 1000 },
        { id_teacher: 813, teacher: "Itzel Estefania Martinez Nieto", monto: 350 },
        { id_teacher: 3100, teacher: "JESSICA JAZMIN MATINEZ FRANCO", monto: 350 },
        { id_teacher: 3090, teacher: "JESUS ADRIAN RANGEL RODRIGUEZ", monto: 500 },
        { id_teacher: 3009, teacher: "JESUS MANUEL FLORES RODRIGUEZ LOPEZ", monto: 350 },
        { id_teacher: 1767, teacher: "JIMENA VILLARREAL VILLARREAL", monto: 350 },
        { id_teacher: 3064, teacher: "JORGE OCTAVIO HERNANDEZ ROSALES", monto: 500 },
        { id_teacher: 3101, teacher: "JOSE DE JESUS CARDENAS DE DIOS", monto: 350 },
        { id_teacher: 2115, teacher: "Lehi Benjamin Santana Paz", monto: 500 },
        { id_teacher: 2365, teacher: "LILIANA FARIAS RUBIO", monto: 350 },
        { id_teacher: 2824, teacher: "MARIA DEL ROCIO ZAMORA RODRIGUEZ", monto: 500 },
        { id_teacher: 2972, teacher: "MARIA FERNANDA ALVAREZ HERNANDEZ", monto: 350 },
        { id_teacher: 3146, teacher: "MARIA FERNANDA CABRERA SANTIAGO", monto: 350 },
        { id_teacher: 2765, teacher: "MARIA FERNANDA PEREZ TRUJILLO", monto: 350 },
        { id_teacher: 2996, teacher: "MARIO EMILIANO GUTIERREZ CORDERO", monto: 350 },
        { id_teacher: 1752, teacher: "Mayela Ruiz Monte de oca", monto: 500 },
        { id_teacher: 1933, teacher: "MELISSA MARIA SALINAS RAMIREZ", monto: 350 },
        { id_teacher: 3060, teacher: "MICHELLE SALAS FLORES", monto: 350 },
        { id_teacher: 2879, teacher: "MILDRETH ODETTE MARTINEZ GARDUNO", monto: 500 },
        { id_teacher: 3103, teacher: "ODETTE ESPINOSA VARGAS", monto: 350 },
        { id_teacher: 1665, teacher: "Oscar Alberto Vargas Jiménez", monto: 350 },
        { id_teacher: 3144, teacher: "REISEL AMERICA DIMAS DOMINGUEZ", monto: 350 },
        { id_teacher: 1568, teacher: "samantha garza gonzalez", monto: 350 },
        { id_teacher: 2551, teacher: "Saul Villalobos Sanchez", monto: 500 },
        { id_teacher: 3126, teacher: "SEBASTIAN TADEO RODRIGUEZ FLORES", monto: 350 },
        { id_teacher: 1841, teacher: "TALIA LINNETH WILLIS LOPEZ", monto: 500 },
        { id_teacher: 1869, teacher: "TATIANA ESCAMILLA ACOSTA", monto: 500 },
        { id_teacher: 2433, teacher: "VANESSA IVONNE HERNANDEZ HERNANDEZ", monto: 350 },
        { id_teacher: 1923, teacher: "VANIA YAMILETH CEPEDA GUERRA", monto: 1000 },
        { id_teacher: 1085, teacher: "VERONICA XIADANY CUEVAS LICEA", monto: 500 },
        { id_teacher: 855, teacher: "Veronica Yamiled Guerrero Sanchez", monto: 350 },
      ]

      const bonos_anteriores = bonosFijos08_26.map((el) => ({
        id_teacher: el.id_teacher,
        teacher: el.teacher,
        monto: this.format(el.monto),
      }))

      const buscarAnterior = (teacher, idTeacher) => {
        const byId = bonos_anteriores.find((el) => Number(el.id_teacher) === Number(idTeacher))
        if (byId) return byId
        const norm = normalizarNombre(teacher)
        return bonos_anteriores.find((el) => normalizarNombre(el.teacher) === norm)
      }

      // Actual solo del rol en vivo (no historial: ahí se igualaba a 24,800)
      const bonos = this.teachersConBonoCompletos
        .filter((el) => parseBono(el.bono_teacher) > 0)
        .map((el) => Object.assign({}, el))

      for (const i in bonos) {
        const { id_teacher, bono_teacher, teacher } = bonos[i]
        const existeAnterior = buscarAnterior(teacher, id_teacher)
        const bono_anterior_monto = existeAnterior ? parseBono(existeAnterior.monto) : 0
        const nuevo_monto = parseBono(bono_teacher)
        bonos[i].bono_teacher = bono_teacher ? bono_teacher : this.format(0)
        bonos[i].bono_anterior = existeAnterior ? existeAnterior.monto : this.format(0)
        bonos[i].diferencia = this.format(nuevo_monto - bono_anterior_monto)
      }

      for (const i in bonos_anteriores) {
        const { id_teacher, monto, teacher } = bonos_anteriores[i]
        const existeTeacher = bonos.find((el) =>
          Number(el.id_teacher) === Number(id_teacher)
          || normalizarNombre(el.teacher) === normalizarNombre(teacher)
        )
        if (!existeTeacher) {
          bonos.push({
            id_teacher,
            teacher,
            bono_anterior: monto,
            bono_teacher: this.format(0),
            diferencia: this.format(0 - parseBono(monto)),
          })
        }
      }

      bonos.push({
        id_teacher: 100000,
        teacher: 'TOTAL',
        bono_anterior: this.format(29700),
        bono_teacher: this.format(bonos.map((item) => parseBono(item.bono_teacher)).reduce((prev, curr) => prev + curr, 0)),
        diferencia: this.format(
          bonos.map((item) => parseBono(item.bono_teacher)).reduce((prev, curr) => prev + curr, 0) - 29700
        ),
      })

      return bonos
  }

},

watch: {

  async selectedHeaders( value, oldValue ){
    this.headersNomina = [
      { text: 'id'                    , value: 'id_teacher'      },
      { text: 'Teacher'               , value: 'teacher'         },  
      { text: 'Categoría'             , value: 'aceptado'        },  
      { text: 'HSBC'                  , value: 'hsbc'            },  
      { text: 'Plantel'               , value: 'plantel'         },  
      { text: 'existeCategoria'       , value: 'existeCategoria' },  
      { text: 'PAGO_SABADO'           , value: 'PAGO_SABADO'     },
      { text: 'PAGO_DOBLES_SABADO'    ,  value: 'PAGO_DOBLES_SABADO'        },  

    ]

    if( [1,3].includes( this.selectedHeaders ) ){
      this.headersNomina.push({
        text: 'PAGO QUINCENA', 
        value: 'pago_quincena',
        align: 'end'
      })
    }


    if( [1].includes( this.selectedHeaders ) ){
      this.headersNomina.push({
        text: 'PAGO BONO', 
        value: 'bono_teacher',
        align: 'end'
      })
    }

    if( value && oldValue != null && oldValue !== value && this.ciclo ){
      await this.actualizarNomina()
    }
  },

  llaveSeguro: {
    handler( ){
      this.getSegurosTeachers()
    },
    immediate: true
  }

},

async created () {


  this.headersNomina = [
    { text: 'id'              , value: 'id_teacher'      },
    { text: 'Teacher'         , value: 'teacher'         },  
    { text: 'Categoría'       , value: 'aceptado'        },  
    { text: 'HSBC'            , value: 'hsbc'            },  
    { text: 'Plantel'         , value: 'plantel'         },  
    { text: 'existeCategoria' , value: 'existeCategoria' },  
    { text: 'PAGO_SABADO'     , value: 'PAGO_SABADO'     },  
    { text: 'PAGO_DOBLES_SABADO'     , value: 'PAGO_DOBLES_SABADO'     },  
    { text: 'PAGO_SABADO_TOTAL'     , value: 'PAGO_SABADO_TOTAL'     },  
  ]

  if( this.selectedHeaders == 1 ){
    this.headersNomina.push({
      text: 'PAGO QUINCENA', 
      value: 'pago_quincena',
      align: 'end'
    })

    this.headersNomina.push({
      text: 'PAGO BONO', 
      value: 'bono_teacher',
      align: 'end'
    })

    this.headersNomina.push({
      text: 'PAGO_DOBLES', 
      value: 'PAGO_DOBLES',
      align: 'end'
    })
  }

  if( this.selectedHeaders == 3 ){
    this.headersNomina.push({
      text: 'PAGO QUINCENA', 
      value: 'pago_quincena',
      align: 'end'
    })

    this.headersNomina.push({
      text: 'PAGO_DOBLES', 
      value: 'PAGO_DOBLES',
      align: 'end'
    })
  }

  

  this.headersNomina.push({
    text: 'REBAJES', 
    value: 'REBAJES',
    align: 'end'
  })

  // this.headersNomina.push({
  //   text: 'PAGO TOTAL Q', 
  //   value: 'total_final',
  //   align: 'end'
  // })
  
  // Depende de la semana, son los campos que se van a llenar o a agregar en los headers de la tabla 1

  await this.getTeachersSinCategoria( )
  await this.actualizarNomina()

},

methods:{

  async actualizarNomina( ){
    await this.inciarNominaSabtina()
    if( !this.ciclo ) return
    await this.cargarHuellasNomina()
  },

  subirRequisicion( ){
    if( this.huellasPendientesRevision ){
      return this.validarErrorDirecto('Revisa los teachers sin huella antes de subir la requisición')
    }
    this.crearRequi()
  },

  getTeachersSinCategoria( ){
    this.liberar = false
    this.$http.get('teachers.sin.categoria').then(response=>{

      this.liberar  = response.data.length > 0 ? false : true
      this.maestros = response.data.map(( registro ) => { return registro.nombre_completo })
    }).catch( error =>{
      this.validarError( error.response.data.message )
    }).finally( () => { this.cargar = false })  
  },

  subirRequisicion () {
    if( !this.puedeSubirRequisicionNomina ){
      return this.validarErrorDirecto('No tienes permiso para subir la requisición')
    }
    this.crearRequi()
  },

  abrirHuellas (tipo) {
    if( this.esNominaSinCantidades ){
      return this.validarErrorDirecto('No tienes permiso para revisar teachers sin huella')
    }
    this.tipoHuellas = tipo
    this.searchHuellas = ''
    this.dialogHuellas = true
  },

  verComentarios( comentarios, tipo_nomina , item ){
    this.renglonNomina = item
    this.comentarios = comentarios
    this.tipo_nomina = tipo_nomina
    this.dialogVerComentario = true
  },

  parseMontoNomina( valor ){
    const n = parseFloat(String(valor == null ? '' : valor).replace(/[$,]/g, ''))
    return isNaN(n) ? 0 : n
  },

  normalizarNombreTeacher( nombre ){
    return String(nombre || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase()
  },

  // La comparativa de bonos incluye teachers que no tienen clases esta semana.
  // El Excel de nómina sale del listado de clases y por eso no los traía.
  filasExcelConBonosFaltantes( filas ){
    const lista = (filas || []).map(el => Object.assign({}, el))
    if( Number(this.selectedHeaders) !== 1 ) return lista

    const bonos = (this.tablaBonos || []).filter(b => {
      return b && b.teacher && b.teacher !== 'TOTAL' && Number(b.id_teacher) !== 100000
    })

    const yaEsta = {}
    lista.forEach(f => {
      if( f.id_teacher != null && f.teacher !== 'TOTAL' ) yaEsta['id:' + Number(f.id_teacher)] = true
      if( f.teacher && f.teacher !== 'TOTAL' ) yaEsta['n:' + this.normalizarNombreTeacher(f.teacher)] = true
    })

    const plantilla = lista.find(f => f.teacher && f.teacher !== 'TOTAL' && Number(f.id_teacher) !== 100000) || {}
    const extras = []

    bonos.forEach(b => {
      const monto = this.parseMontoNomina(b.bono_teacher)
      if( monto <= 0 ) return

      const idKey = 'id:' + Number(b.id_teacher)
      const nomKey = 'n:' + this.normalizarNombreTeacher(b.teacher)
      if( yaEsta[idKey] || yaEsta[nomKey] ){
        const fila = lista.find(f => {
          return f.teacher !== 'TOTAL' && (
            Number(f.id_teacher) === Number(b.id_teacher) ||
            this.normalizarNombreTeacher(f.teacher) === this.normalizarNombreTeacher(b.teacher)
          )
        })
        if( fila && this.parseMontoNomina(fila.bono_teacher) === 0 ){
          fila.bono_teacher = b.bono_teacher
        }
        return
      }

      const row = {}
      Object.keys(plantilla).forEach(k => {
        const v = plantilla[k]
        if( typeof v === 'number' ) row[k] = 0
        else if( typeof v === 'string' && v.indexOf('$') === 0 ) row[k] = '$0.00'
        else if( v == null || typeof v === 'string' || typeof v === 'boolean' ) row[k] = ''
      })
      row.id_teacher = b.id_teacher
      row.teacher = b.teacher
      row.bono_teacher = b.bono_teacher
      row.plantel = b.plantel || ''
      extras.push(row)
      yaEsta[idKey] = true
      yaEsta[nomKey] = true
    })

    const idxTotal = lista.findIndex(f => f.teacher === 'TOTAL' || Number(f.id_teacher) === 100000)
    if( idxTotal >= 0 ){
      extras.forEach((row, i) => lista.splice(idxTotal + i, 0, row))
    }else{
      extras.forEach(row => lista.push(row))
    }

    const totalIdx = lista.findIndex(f => f.teacher === 'TOTAL' || Number(f.id_teacher) === 100000)
    if( totalIdx >= 0 ){
      const suma = lista.reduce((s, f) => {
        if( f.teacher === 'TOTAL' || Number(f.id_teacher) === 100000 ) return s
        return s + this.parseMontoNomina(f.bono_teacher)
      }, 0)
      lista[totalIdx].bono_teacher = this.format(suma)
    }

    return lista
  },

  exportar( ){
    const datosBase = this.filasExcelConBonosFaltantes(this.filterTeachersSeguro.map( el => Object.assign( {}, el, {
      seguro: this.segurosTeachers[el.id_teacher] ? 'Sí' : 'No'
    })))
    if( !this.esNominaSinCantidades ){
      return this.exportExcel( datosBase, 'teachers' )
    }
    const keysOk = this.headersNominaVisibles.map( h => h.value ).concat([ 'seguro' ])
    const limpios = datosBase.map( fila => {
      const out = {}
      for( const k of keysOk ){
        if( k === 'seguro' ){ out[k] = fila.seguro; continue }
        if( Object.prototype.hasOwnProperty.call(fila, k) ) out[k] = fila[k]
      }
      return out
    })
    this.exportExcel( limpios, 'teachers')
  },

  getSegurosTeachers( ){
    this.segurosTeachers = {}
    if( !this.ciclo || !this.ciclo.id_ciclo || !this.selectedHeaders ) return

    const payload = {
      id_ciclo: this.ciclo.id_ciclo,
      semana  : this.selectedHeaders,
    }

    this.$http.post('nomina.teacher.seguro.list', payload).then(response=>{
      const seguros = {}
      for( const registro of response.data ){
        if( registro.seguro == 1 ){ seguros[registro.id_teacher] = true }
      }
      this.segurosTeachers = seguros
    }).catch( error =>{
      let mensaje = 'No se pudieron cargar los teachers seguros'
      if( error && error.response && error.response.data && error.response.data.message ){
        mensaje = error.response.data.message
      }
      this.validarError( mensaje )
    })
  },

  cambiarSeguro( item, valor ){
    if( !this.ciclo || !this.ciclo.id_ciclo || !this.selectedHeaders ){
      return this.validarErrorDirecto('Selecciona un ciclo y una semana por favor')
    }

    const anterior = !!this.segurosTeachers[item.id_teacher]
    const seguro   = !!valor
    this.$set( this.segurosTeachers, item.id_teacher, seguro )

    const payload = {
      id_teacher: item.id_teacher,
      id_ciclo  : this.ciclo.id_ciclo,
      semana    : this.selectedHeaders,
      seguro    : seguro ? 1 : 0,
      id_usuario: this.getdatosUsuarioERPERP.iderp,
    }

    this.$http.post('nomina.teacher.seguro.update', payload).catch( error =>{
      this.$set( this.segurosTeachers, item.id_teacher, anterior )
      let mensaje = 'No se pudo guardar el seguro'
      if( error && error.response && error.response.data && error.response.data.message ){
        mensaje = error.response.data.message
      }
      this.validarError( mensaje )
    })
  },

  verDesgloseGuardado( ){
    if (!this.ciclo || !this.ciclo.id_ciclo) {
      return this.validarErrorDirecto('Selecciona un ciclo por favor')
    }

    this.dialogDesglose = true
    this.desgloseHistorial = []
    this.searchDesglose = ''
    this.cargar = true

    const payload = {
      id_ciclo: this.ciclo.id_ciclo,
      semana: this.selectedHeaders,
    }

    this.$http.post('get.historial.nomina.teacher', payload).then((response) => {
      this.desgloseHistorial = mapDetalleHistorialRows(response.data.detalle)
    }).catch((error) => {
      const mensaje = error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'No se pudo cargar el desglose guardado'
      this.validarError(mensaje)
    }).finally(() => {
      this.cargar = false
    })
  },

  exportarDesgloseHistorial( ){
    const filas = this.filasExcelConBonosFaltantes(this.desgloseHistorial || [])
    if( !this.esNominaSinCantidades ){
      return this.exportExcel(filas, 'desglose_teachers_sem' + this.selectedHeaders)
    }
    const keysOk = this.headersDesgloseVisibles.map( h => h.value )
    const limpios = filas.map( fila => {
      const out = {}
      for( const k of keysOk ){
        if( Object.prototype.hasOwnProperty.call(fila, k) ) out[k] = fila[k]
      }
      return out
    })
    this.exportExcel(limpios, 'desglose_teachers_sem' + this.selectedHeaders)
  },

  responder ( ) {
    this.cargar = true
    const payload = {
      id_usuario : this.getdatosUsuarioERPERP.iderp,  
      id_teacher : this.renglonNomina.id_teacher,  
      estatus    : [334,966].includes( this.getdatosUsuarioERPERP.iderp ) ? 0 : 2,
      id_ciclo   : this.ciclo.id_ciclo,
      semana     : this.selectedHeaders,
      motivo     : this.respuesta,
      tipo_nomina: this.tipo_nomina,
    }

    this.$http.post('teachers.estatus.responder', payload).then(response=>{
      this.validarSuccess('Datos grabados correctamente')
      this.respuesta    = ''
      this.dialogVerComentario = false
      this.cargar       = false
      this.initialize()
    }).catch( error =>{
      this.validarError( error.response.data.message )
    }).finally( () => { this.cargar = false })  
  },

  format( valor ){
    valor = valor ? valor : 0
    return valor.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN'
    })
  }
}
}
</script>




